module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.data.data,
      "options": _vm.pagination,
      "server-items-length": _vm.totalItems,
      "loading": _vm.loading,
      "footer-props": _vm.footerProps
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      },
      "update:items-per-page": _vm.getItemPerPage
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', [_vm._v(_vm._s(item.ownerNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ownerCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ownerName))])])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-22ad7521"}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Owners.vue
// module id = 925
// module chunks = 1